import React from 'react';
import { useLocation } from 'react-router-dom';

import { Button } from '@sololearnorg/sol';
import useStyles from 'isomorphic-style-loader/useStyles';
import { AuthService, Container } from '../../../../symphony';

import { SlDiscussContext } from '../../global-constants';
import { SlActions } from '../../services/ActionsService/sl-actions';
import { ActionType, MainCTAType, RequestType } from '../../global-interface';

import s from './EmptyQuestions.scss';

interface IEmptyQuestionsProps {
	isMyAnswers: boolean;
	isMyQuestions: boolean;
}

export function EmptyQuestions({
	isMyAnswers,
	isMyQuestions,
}: IEmptyQuestionsProps) {
	useStyles(s);
	const { pathname } = useLocation();
	const isLoggedin = Container.take('global', AuthService).isLoggedIn();
	const getTitle = () => {
		if (!isLoggedin && (isMyAnswers || isMyQuestions)) {
			return 'Sign in required';
		}

		return 'Nothing to show';
	};

	const getDescription = () => {
		if (!isLoggedin && (isMyAnswers || isMyQuestions)) {
			return 'Please sign in to see your answers.';
		}

		if (isMyAnswers) {
			return 'Help someone by answering to their questions and it will appear here.';
		}

		if (isMyQuestions) {
			return 'You have no questions, yet. Your questions will appear here once you ask your first question.';
		}

		return '';
	};

	const getButton = () => {
		if (!isLoggedin && (isMyAnswers || isMyQuestions)) {
			return {
				text: 'Sign in',
				link: `/users/login?returnUrl=${encodeURIComponent(
					`${pathname}`,
				)}`,
				trackText: MainCTAType.SignIn,
			};
		}

		if (isMyAnswers) {
			return {
				text: 'Go to questions',
				link: '/Discuss',
				trackText: MainCTAType.GoToQuestion,
			};
		}

		return {
			text: 'Ask a question',
			link: '/Discuss/New',
			trackText: MainCTAType.AskQuestion,
		};
	};

	const onCTAClick = () => {
		const { actions$ } = Container.take(SlDiscussContext, SlActions);
		const { trackText, link } = getButton();

		actions$.next({
			type: ActionType.OnEmptyQuestionCTAClick,
			requestType: RequestType.Parallel,
			data: {
				ctaType: trackText,
				ctaURL: link,
			},
		});
	};

	return (
		<div className="discuss-empty-questions">
			<div className="discuss-empty-questions__title">{getTitle()}</div>
			<div className="discuss-empty-questions__description">
				{getDescription()}
			</div>
			<Button onClick={onCTAClick}>{getButton().text}</Button>
		</div>
	);
}
